import { Container, Form, FormGroup, Col, Row } from 'react-bootstrap';
import { ControlButtons } from '../ControlButtons';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { blastingTechnicianInfo } from '../../schemas/blastingTechnicianInfoSchema.js';
import { Address } from '../FormFields/Address';
import { PhoneNumber } from '../FormFields/PhoneNumber';
import { StateFormGroup } from '../FormFields/StateFormGroup';

export const BlastingTechnicianInfo = ({
	currBlastingTechInfo,
	onNext = () => {},
	onPrevious = () => {},
	onSubmit = () => {},
	finalStep = false,
	disablePrev = false,
	disableNext = false,
}) => {
	const { formState, register, handleSubmit } = useForm({
		resolver: yupResolver(blastingTechnicianInfo),
		defaultValues: currBlastingTechInfo,
	});
	return (
		<Container className="component mb-3">
			<Container className="component mt-5">
				<h1>Blasting Technician Information</h1>
				<FormGroup>
					<Form.Label>Technician Name</Form.Label>
					<Form.Control type="text" {...register('name')}></Form.Control>
					<Form.Text className="text-danger">
						{formState.errors.name?.message}
					</Form.Text>
				</FormGroup>
				<Address register={register} error={formState.errors}></Address>
				<Row>
					<Col>
						<Form.Group xs="12" md="6">
							<Form.Label>Office Phone:</Form.Label>
							<PhoneNumber
								register={register}
								error={formState.errors}
								registerName="officePhone"
							/>
							<Form.Text className="text-danger">
								{formState.errors.officePhone?.message}
							</Form.Text>
						</Form.Group>
					</Col>
					<Col>
						<Form.Group xs="12" md="6">
							<Form.Label>After Hours Phone:</Form.Label>
							<PhoneNumber
								register={register}
								registerName="afterHourPhone"
								error={formState.errors}
							/>
							<Form.Text className="text-danger">
								{formState.errors.afterHourPhone?.message}
							</Form.Text>
						</Form.Group>
					</Col>
				</Row>
				<Row>
					<Col>
						<Form.Group xs="12" md="6">
							<Form.Label>Drivers License Number:</Form.Label>
							<Form.Control
								type="number"
								{...register('driversLicenseNum')}></Form.Control>
							<Form.Text className="text-danger">
								{formState.errors.driversLicenseNum?.message}
							</Form.Text>
						</Form.Group>
					</Col>
				</Row>
				<Row>
					<Col md="6">
						<StateFormGroup
							register={register}
							error={formState.errors}
							registerName="stateIssuedBy"
							label="State Issued By"
						/>
					</Col>
					<Col md="6">
						<Form.Group xs="12" md="6">
							<Form.Label>Date Of Birth:</Form.Label>
							<Form.Control
								type="date"
								{...register('dateOfBirth')}></Form.Control>
							<Form.Text className="text-danger">
								{formState.errors.dateOfBirth?.message}
							</Form.Text>
						</Form.Group>
					</Col>
				</Row>
			</Container>
			<ControlButtons
				onNext={handleSubmit(onNext)}
				onPrev={onPrevious}
				onSubmit={onSubmit}
				disablePrev={disablePrev}
				disableNext={disableNext}
				finalStep={finalStep}></ControlButtons>
		</Container>
	);
};
